import { FileButtonPremium } from '@components'

import { Tooltip } from '@billy/design-system'
import { useUploady } from '@rpldy/uploady'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { TrackingContext } from '../../../../enums/trackingContext'
import { ACCEPTED_ATTACHMENT_MIME_EXTENSIONS } from '../../constants/acceptedAttachmentMimeExtensions'

export const AttachmentsPicker = (): ReactElement => {
  const { t } = useTranslation()
  const uploady = useUploady()

  const handleFilesSelect = useCallback(
    (file: File[]) => {
      uploady.upload(file)
    },
    [uploady],
  )

  return (
    <Tooltip label={t('attachments_section.upload_button.tooltip')} placement="top">
      <FileButtonPremium
        accept={ACCEPTED_ATTACHMENT_MIME_EXTENSIONS}
        centered
        fullRound
        icon="paperclip"
        multiple
        onFilesSelect={handleFilesSelect}
        size="md"
        trackingContext={TrackingContext.Attachments}
        variant="tonal"
      />
    </Tooltip>
  )
}
